// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__jJnY4","header__title":"Header_header__title__3yE5A","header__title__highlight":"Header_header__title__highlight__XnFfU"};